import { Component, OnInit } from '@angular/core';
import {FormBuilder} from "@angular/forms";
import {DynamicScriptLoaderServiceService} from "../../_services/dynamic-script-loader-service.service";
import {AuthenicationService} from "../../_services/authenication.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PatientsService} from "../../_services/patients.service";
import {ToasterService} from "../../_services/toaster.service";
import {UserService} from "../../_services/user.service";

declare var $: any;

@Component({
  selector: 'app-singletestresult',
  templateUrl: './singletestresult.component.html',
  styleUrls: ['./singletestresult.component.css']
})
export class SingletestresultComponent implements OnInit {


  userdetaild: string;
  returnUrl: string;
  testlist: any;
  questions: any[] = [];

  id: string = this.route.snapshot.params['id'];

  constructor(private formBuilder: FormBuilder, private dynamicScriptLoader: DynamicScriptLoaderServiceService, private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private patientsService: PatientsService, private toaster: ToasterService, private userservice: UserService) { }

  ngOnInit() {

    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }


    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';


    this.getSingleTestResult(this.id);
  }

  getSingleTestResult(id) {
    this.userservice.getSingleTestResult(id)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('MindPeers', data.ResponseMessage);
              let response = data.testData;

              for (let entry of response.test_reports){
                 // console.log(entry);
                this.userservice.getTestSingleQuestionById(entry.question_id)
                  .subscribe((ansdata: any) => {
                    let newquestionarray = {
                      question: ansdata.questionsList[0],
                      given_answer: entry.answer_options,
                      given_answer_point: entry.answer_point,
                    };

                    this.questions.push(newquestionarray);
                  })
              }

              const res = {
                _id: response._id,
                cat_id: response.cat_id,
                user_id: response.user_id,
                today_feeling: response.today_feeling,
                troubles: response.troubles,
                totalpoints: response.totalpoints,
                percentage: response.percentage,
                test_reports: this.questions,
                createdAt: response.createdAt,
                updatedAt: response.updatedAt
              };

            this.testlist = res;


          } else {
            this.toaster.showError('MindPeers', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('MindPeers', error.error.ResponseMessage);
        });
  }


}
